import axios from 'axios'
import {BUSCAR_DESCONTO_USUARIO_ROTA} from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarDescontosUsuarioRota (idEmpresa, idUsuario) {
  const url = `${URL}/desconto-usuario-rota/empresa/${idEmpresa}/usuario/${idUsuario}/descontos-usuario-rota`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_DESCONTO_USUARIO_ROTA,
        payload: response

      })
  );
}
